<template>
  <div class="card">
    <div
      v-if="!loading && !serviceOrder"
      class="p-d-flex p-jc-center p-ai-center p-flex-column"
      style="min-height: 160px; gap: 1rem;"
    >
      <Message severity="info" :closable="false">
        Não existe ordem de serviço associada a este PAT.
      </Message>
      <Button
        v-if="isLgBrand"
        label="Criar Ordem de Serviço"
        icon="pi pi-plus"
        class="p-button-success"
        @click="showLgCreateForm = true"
      />
    </div>

    <LgCreateFromPat
      v-if="isLgBrand"
      :showForm="showLgCreateForm"
      :prefillPatId="patId"
      :prefillModelCode="patInfo && patInfo.equipment ? patInfo.equipment.model : null"
      @serviceOrderCreated="onServiceOrderCreated"
      @cancel="showLgCreateForm = false"
    />

    <div v-if="serviceOrder" class="container">
      <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />

      <div>
        <PatLgDetail
          v-if="isLg"
          :serviceOrder="serviceOrder"
          :patId="patId"
        />
        <PatHisenseDetail
          v-else-if="isHisense"
          :serviceOrder="serviceOrder"
          :patId="patId"
          @update:serviceOrder="updateServiceOrder"
        />
        <PatDgDetail
          v-else-if="isDg"
          :serviceOrder="serviceOrder"
          @updated="updateServiceOrder"
        />
        <PatDetailExtranet
          v-else-if="isExtranet"
          :serviceOrder="serviceOrder"
          @update:serviceOrder="updateServiceOrder"
        />
      </div>
    </div>

    <Loading :active.sync="loading" />
  </div>
</template>

<script>
import serviceOrdersService from "@/services/serviceOrders.service";
import PatHisenseDetail from "@/components/pats/PatHisenseDetail.vue";
import PatLgDetail from "@/components/pats/PatLgDetail.vue";
import PatDgDetail from "@/components/pats/PatDgDetail.vue";
import PatDetailExtranet from "@/components/pats/PatDetailExtranet.vue";
import LgCreateFromPat from "@/components/serviceOrders/LgCreateFromPat.vue";

export default {
  name: "PatServiceWorkerComponent",
  props: ["patId", "brand", "patInfo"],
  components: {
    PatHisenseDetail,
    PatLgDetail,
    PatDgDetail,
    PatDetailExtranet,
    LgCreateFromPat,
  },
  data() {
    return {
      serviceOrder: null,
      loading: false,
      showLgCreateForm: false,
    };
  },
  computed: {
    isLgBrand() {
      return String(this.brand || "").trim().toLowerCase().includes("lg");
    },
    source() {
      if (!this.serviceOrder) {
        return null;
      }
      if (this.serviceOrder.__source) {
        return this.serviceOrder.__source;
      }
      if (this.serviceOrder.origin === "DG") {
        return "dg";
      }

      if (this.serviceOrder.origin === "EXTRANET") {
        return "extranet";
      }

      const fallback = String(this.brand || "").trim().toLowerCase();
      if (fallback.includes("lg")) return "lg";
      if (fallback.includes("hisense")) return "hisense";
      return null;
    },
    isLg() {
      return this.source === "lg";
    },
    isHisense() {
      return this.source === "hisense";
    },
    isDg() {
      return this.source === "dg";
    },
    isExtranet() {
      return this.source === "extranet";
    },
  },
  async mounted() {
    await this.loadServiceOrder();
  },
  methods: {
    async loadServiceOrder() {
        try {
          this.loading = true;
          this.serviceOrder = await serviceOrdersService.getServiceOrderByBrandAndPat(
                this.patId
            );
        } catch (error) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao carregar a Ordem de Serviço",
            detail: error.message,
            life: 3000,
          });
        } finally {
          this.loading = false;
        }
    },
    updateServiceOrder(serviceOrder) {
      this.serviceOrder = serviceOrder;
    },
    onServiceOrderCreated(response) {
      this.showLgCreateForm = false;
      this.serviceOrder = response.serviceOrder;
    }
  },
};
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  overflow: auto;
  padding: 10px;
}
</style>

<style lang="css" scoped>
:deep(.p-message-text) {
  width: 100% !important;
}
</style>
